import { FeedbackScoreCard } from "@/pages/recruit/scorecards/feedback/FeedbackScoreCard.tsx";
import { RouteConfig } from "@/routes/types/route.types.ts";
import { ApiFeatureType } from "@/types/subscription.types.ts";

export const feedbackRoutes: RouteConfig[] = [
  {
    path: "/feedbacks",
    planFeature: ApiFeatureType.ats,
    children: [
      {
        path: ":feedback_id/candidates/:candidate_id",
        element: <FeedbackScoreCard />,
        isFullScreen: true,
      },
    ],
  },
];
